<template>
  <fragment>
    <!--LIST-->
    <td
      v-if="$store.state.app.showAdministration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAdministrationVer"
          hide-details
          class="my-1"
          @click="checkAllListBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--EDIT-->
    <td
      v-if="$store.state.app.showAdministration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAdministrationEdit"
          hide-details
          class="my-1"
          @click="checkAllEditBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--CREATE-->
    <td
      v-if="$store.state.app.showAdministration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAdministrationCreate"
          hide-details
          class="my-1"
          @click="checkAllCreateBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--DESTROY-->
    <td
      v-if="$store.state.app.showAdministration"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAdministrationDelete"
          hide-details
          class="my-1"
          @click="checkAllDestroyBooking()"
        ></v-checkbox>
      </div>
    </td>
    <td
      :key="Math.random() * (index + 1)"
      style="min-width: 50px;"
    ></td>
  </fragment>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    index: {
      type: Number,
    },
  },
  computed: {
    ...mapState({
      sourcePermisos: state => state.app.sourcePermisos,
    }),
  },
  methods: {
    checkAllListBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAdministration = false
      if (this.sourcePermisos[this.index].all.checkboxAdministrationVer) {
        this.sourcePermisos[this.index].permisos.push('ctas_x_cobrar:list')
        this.sourcePermisos[this.index].permisos.push('ctas_x_pagar:list')
        this.sourcePermisos[this.index].permisos.push('pays_recibidos:list')
        this.sourcePermisos[this.index].permisos.push('pays_emitidos:list')
        this.sourcePermisos[this.index].permisos.push('markup:list')
        this.sourcePermisos[this.index].permisos.push('finanzas:list')
        this.sourcePermisos[this.index].permisos.push('comisiones:list')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'finanzas:list'
            && e !== 'ctas_x_cobrar:list'
            && e !== 'ctas_x_pagar:list'
            && e !== 'pays_recibidos:list'
            && e !== 'pays_emitidos:list'
            && e !== 'comisiones:list'
            && e !== 'markup:list',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAdministration = !this.$store.state.app.showAdministration
      }, 10)
    },
    checkAllEditBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAdministration = false
      if (this.sourcePermisos[this.index].all.checkboxAdministrationEdit) {
        this.sourcePermisos[this.index].permisos.push('ctas_x_cobrar:edit')
        this.sourcePermisos[this.index].permisos.push('ctas_x_pagar:edit')
        this.sourcePermisos[this.index].permisos.push('pays_recibidos:edit')
        this.sourcePermisos[this.index].permisos.push('pays_emitidos:edit')
        this.sourcePermisos[this.index].permisos.push('markup:edit')
        this.sourcePermisos[this.index].permisos.push('finanzas:edit')
        this.sourcePermisos[this.index].permisos.push('comisiones:edit')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'finanzas:edit'
            && e !== 'ctas_x_cobrar:edit'
            && e !== 'ctas_x_pagar:edit'
            && e !== 'pays_recibidos:edit'
            && e !== 'pays_emitidos:edit'
            && e !== 'comisiones:edit'
            && e !== 'markup:edit',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAdministration = !this.$store.state.app.showAdministration
      }, 10)
    },
    checkAllCreateBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAdministration = false
      if (this.sourcePermisos[this.index].all.checkboxAdministrationCreate) {
        this.sourcePermisos[this.index].permisos.push('ctas_x_cobrar:create')
        this.sourcePermisos[this.index].permisos.push('ctas_x_pagar:create')
        this.sourcePermisos[this.index].permisos.push('pays_recibidos:create')
        this.sourcePermisos[this.index].permisos.push('pays_emitidos:create')
        this.sourcePermisos[this.index].permisos.push('markup:create')
        this.sourcePermisos[this.index].permisos.push('finanzas:create')
        this.sourcePermisos[this.index].permisos.push('comisiones:create')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'finanzas:create'
            && e !== 'ctas_x_cobrar:create'
            && e !== 'ctas_x_pagar:create'
            && e !== 'pays_recibidos:create'
            && e !== 'pays_emitidos:create'
            && e !== 'comisiones:create'
            && e !== 'markup:create',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAdministration = !this.$store.state.app.showAdministration
      }, 10)
    },
    checkAllDestroyBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAdministration = false
      if (this.sourcePermisos[this.index].all.checkboxAdministrationDelete) {
        this.sourcePermisos[this.index].permisos.push('ctas_x_cobrar:destroy')
        this.sourcePermisos[this.index].permisos.push('ctas_x_pagar:destroy')
        this.sourcePermisos[this.index].permisos.push('pays_recibidos:destroy')
        this.sourcePermisos[this.index].permisos.push('pays_emitidos:destroy')
        this.sourcePermisos[this.index].permisos.push('finanzas:destroy')
        this.sourcePermisos[this.index].permisos.push('comisiones:destroy')
        this.sourcePermisos[this.index].permisos.push('markup:destroy')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'finanzas:destroy'
            && e !== 'ctas_x_cobrar:destroy'
            && e !== 'ctas_x_pagar:destroy'
            && e !== 'pays_recibidos:destroy'
            && e !== 'pays_emitidos:destroy'
            && e !== 'comisiones:destroy'
            && e !== 'markup:destroy',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAdministration = !this.$store.state.app.showAdministration
      }, 10)
    },
  },
}
</script>
